<template>
    <div class="fluid-container text-center">
        <div 
            class="alert"
            role="alert"
            :class="{ 'alert-success': type === 'success', 'alert-danger': type === 'error'}"
        >
            <div class="flash-status ">{{ message }}</div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        message: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'success',
            required: false,
        }
    },
    components: {
    },
    methods: {
    }
}
</script>

<style lang="scss">
</style>
